const OPTIONS_HIGH = { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 };
const OPTIONS_FALLBACK = { enableHighAccuracy: false, timeout: 20000, maximumAge: 60000 };

/**
 * Two-stage geolocation: try a high-accuracy GPS fix first, then fall back to
 * network/Wi-Fi positioning. High accuracy alone routinely times out on mobile
 * (weak GPS indoors, slow first fix) even when the device's location is on.
 * Accuracy is recorded with every reading, so the office can see fix quality.
 */
export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("geolocation-unsupported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      resolve,
      () => {
        navigator.geolocation.getCurrentPosition(resolve, reject, OPTIONS_FALLBACK);
      },
      OPTIONS_HIGH
    );
  });
}
